import { defineI18nConfig } from '#imports';

export default defineI18nConfig(() => ({
  missingWarn: false,
}));
